import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-070985f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "eoc-relative" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "eoc-fade" }, null, -1))


export default /*#__PURE__*/_defineComponent({
  __name: 'EOCButton',
  props: {
    text: null
  },
  setup(__props: any) {

/**
 * End-of-content button.
 *
 * Shows fade and a button to go to billing page.
 */


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_router_link, {
      to: { name: 'billing' },
      class: "btns eoc-button"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(__props.text), 1)
      ]),
      _: 1
    })
  ]))
}
}

})